<template>
  <div class="price-tip">
    Factory price ≈
    &nbsp;
    <span class="price-tip__highlight">1/10 to 1/3 of retail price</span>.
    <span>&nbsp;Unsure?&nbsp;</span>
    Snap
    <Popover
      placement="bottom"
      trigger="click"
      :disabled="deviceType === 'MOBILE'"
    >
      <template #reference>
        <img
          class="price-tip__camera"
          src="@/assets/colorIcon/camera.svg"
          @click="onCamera"
        >
      </template>
      <SearchImg />
    </Popover>
    & search for price range!
  </div>
</template>

<script setup>
import { isMobile } from '@/utils/constants'
import { Popover } from '../Popover'
import { SearchImg } from '../Search'
import { showH5ImageSearchGuide } from '@/components/H5/H5ImageSearchGuide'

const onCamera = () => {
  if (!isMobile) return
  showH5ImageSearchGuide()
}
</script>

<style lang="less" scoped>
.price-tip {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-family: mon-500;
  font-size: 11px;
  line-height: 14px;
  color: #5C5C5C;
  width: 268px;

  @media (min-width: 768px) {
    width: auto;
  }

  &__highlight {
    font-family: mon-600;
    color: #052784;
  }

  &__camera {
    cursor: pointer;
  }
}
</style>
